<div class="panel panel-default border-0 not-print">
    <div class="panel-body">
        <div class="btn-option">
            <button
                *ngIf="showReportes && stepper === 5"
                ngxPrint
                class="btn btn-primary float-right"
                printSectionId="print-section"
                [printTitle]='"FlujoDeCredito_"+(rut | rutFormat)+"_"+today'
                [useExistingCss]="true">
                Descargar PDF
            </button>
        </div>
    </div>
</div>

<div class="print-section">
    <div class="mb-4 avoid-break-inside" *ngIf="reportesPrincipalesObj">
        <app-alert-f29 
            [reportesPrincipalesObj]="reportesPrincipalesObj"
            [addCarpeta]="true"
            [addHistorico]="true"
            [addCalculado]="true"
            class="w-100"
        ></app-alert-f29>
    </div>

    <h2>Antecendentes Cliente</h2>
    <div class="ficha border">
        <div class="col izquierda">
            <div *ngIf="objReporteBasico" class="fila border-bottom-line">
                <span class="custom-label">Razón Social:</span>
                <span class="value">{{ objReporteBasico?.InformacionBasica?.NombreORazonSocial || 'Sin información'
                    }}</span>
            </div>

            <div class="fila border-bottom-line">
                <span class="custom-label">Rut:</span>
                <span class="value">{{ rut | rutFormat }}</span>
            </div>

            <div *ngIf="objReporteBasico && ((isPersonaNatural && reporteConInformeComercial === true) || !isPersonaNatural)" class="fila border-bottom-line">
                <span class="custom-label">Dirección:</span>
                <span class="value">{{ direccion || 'Sin información' }}</span>
            </div>

            <div *ngIf="objReporteBasico" class="fila border-bottom-line">
                <span class="custom-label">Actividad económica:</span>
                <span class="value">{{ objReporteBasico?.Riesgo?.ActividadEconomica || 'Sin información' }}</span>
            </div>

            <div *ngIf="objReporteBasico" class="fila border-bottom-line">
                <span class="custom-label">Sector Industrial:</span>
                <span class="value">{{ objReporteBasico?.Riesgo?.Industria || 'Sin información' }}</span>
            </div>

            <div *ngIf="objReporteBasico" class="fila border-bottom-line">
                <span class="custom-label">Subsector Industrial:</span>
                <span class="value">{{ objReporteBasico?.Riesgo?.Subsector || 'Sin información' }}</span>
            </div>

            <div *ngIf="objReporteBasico" class="fila border-bottom-line">
                <span class="custom-label">Iniciación de Actividades:</span>
                <span class="value">
                    {{
                        objReporteBasico?.InformacionBasica?.AnoInicioActividades && objReporteBasico?.InformacionBasica?.AnoInicioActividades !== 'Sin Inicio de Actividades' ?
                        (objReporteBasico?.InformacionBasica?.AnoInicioActividades | date:'dd-MM-yyyy') :
                        objReporteBasico?.InformacionBasica?.AnoInicioActividades || 'Sin información'
                    }}
                </span>
            </div>

            <div *ngIf="objReporteBasico?.InformacionBasica?.TerminoGiro === true" class="fila border-bottom-line">
                <span class="custom-label">Fecha Termino de Giro:</span>
                <span class="value">{{ objReporteBasico?.InformacionBasica?.FechaTerminoGiro | date:'dd-MM-yyyy' }}</span>
            </div>

            <ng-container *ngIf="objReporteBasico">

                <ng-container *ngIf="isPersonaNatural; else isNotPersonaNatural">
                    <ng-container *ngIf="reporteConInformeComercial === true">
                        <div class="fila border-bottom-line">
                            <span class="custom-label">Edad:</span>
                            <span class="value">{{ objReporteBasico?.InformacionPersonal?.Edad || 'Sin información'
                                }}</span>
                        </div>

                        <div class="fila border-bottom-line">
                            <span class="custom-label">Fecha Nacimiento:</span>
                            <span class="value">
                                {{
                                objReporteBasico?.InformacionPersonal?.FechaNacimiento ?
                                (objReporteBasico?.InformacionPersonal?.FechaNacimiento | date: 'dd-MM-yyyy') :
                                'Sin información'
                                }}
                            </span>
                        </div>

                        <div class="fila border-bottom-line">
                            <span class="custom-label">Nacionalidad:</span>
                            <span class="value">{{ objReporteBasico?.InformacionPersonal?.Nacionalidad || 'Sin información'
                                }}</span>
                        </div>

                        <ng-container *ngIf="telefonos && telefonos.length > 1; else elseTelefonos">
                            <div class="fila border-bottom-line">
                                <span class="custom-label">Teléfonos:</span>
                                <ul class="value pl-4">
                                    <li *ngFor="let item of telefonos">
                                        {{ item?.Telefono || 'Sin información' }}
                                    </li>
                                </ul>
                            </div>
                        </ng-container>

                        <ng-template #elseTelefonos>
                            <div class="fila border-bottom-line">
                                <span class="custom-label">Teléfono:</span>
                                <span class="value">{{ telefonos[0]?.Telefono || 'Sin información' }}</span>
                            </div>
                        </ng-template>

                        <div class="fila border-bottom-line">
                            <span class="custom-label">Email:</span>
                            <span class="value">{{ objReporteBasico?.InformacionPersonal?.Contactabilidad?.Email?.Email ||
                                'Sin información' }}</span>
                        </div>

                        <div class="fila border-bottom-line">
                            <span class="custom-label">Fecha Email:</span>
                            <span class="value">
                                {{ formatFechaEmailPN(objReporteBasico?.InformacionPersonal?.Contactabilidad?.Email?.FechaEmail) || 'Sin información' }}
                            </span>
                        </div>

                        <div class="fila border-bottom-line">
                            <span class="custom-label">Descripcion Estado Marital:</span>
                            <span class="value">{{ objReporteBasico?.InformacionPersonal?.Familia?.DescripcionEstadoMarital
                                || 'Sin información' }}</span>
                        </div>

                        <div class="fila border-bottom-line">
                            <span class="custom-label">Rut Conyugue:</span>
                            <span class="value">
                                {{
                                    objReporteBasico?.InformacionPersonal?.Familia?.RutConyugue ?
                                    ((objReporteBasico?.InformacionPersonal?.Familia?.RutConyugue || '') | rutFormat) :
                                    'Sin información'
                                }}
                            </span>
                        </div>

                        <div class="fila border-bottom-line">
                            <span class="custom-label">Fecha de Matrimonio:</span>
                            <span class="value">
                                {{
                                objReporteBasico?.InformacionPersonal?.Familia?.FechaDeMatrimonio ?
                                (objReporteBasico?.InformacionPersonal?.Familia?.FechaDeMatrimonio | date: 'dd-MM-yyyy') :
                                'Sin información'
                                }}
                            </span>
                        </div>
                    </ng-container>
                </ng-container>

                <ng-template #isNotPersonaNatural>

                    <ng-container *ngIf="telefonos && telefonos.length > 1; else elseTelefonos">
                        <div class="fila border-bottom-line">
                            <span class="custom-label">Teléfonos:</span>
                            <mat-list>
                                <mat-list-item *ngFor="let item of telefonos">
                                    <span matListItemTitle class="font-size-normal">{{ item?.Telefono || 'Sin información' }}</span>
                                    <span *ngIf="item?.FechaTelefono" matListItemLine>Fecha teléfono: {{ item?.FechaTelefono | date: 'dd-MM-yyyy' }}</span>
                                </mat-list-item>
                            </mat-list>
                        </div>
                    </ng-container>

                    <ng-template #elseTelefonos>
                        <div class="fila border-bottom-line">
                            <span class="custom-label">Teléfono:</span>
                            <span class="value">{{ telefonos[0]?.Telefono || 'Sin información' }}</span>
                        </div>
                        <div class="fila border-bottom-line">
                            <span class="custom-label">Fecha Teléfono:</span>
                            <span class="value">
                                {{
                                telefonos[0]?.FechaTelefono ?
                                (telefonos[0]?.FechaTelefono | date: 'dd-MM-yyyy') :
                                'Sin información'
                                }}
                            </span>
                        </div>
                    </ng-template>

                    <div *ngIf="reporteConInformeComercial === true" class="fila border-bottom-line">
                        <span class="custom-label">Email:</span>
                        <span class="value">{{ objReporteBasico?.ContactabilidadComercial?.Email || 'Sin información'
                            }}</span>
                    </div>

                    <div *ngIf="reporteConInformeComercial === true" class="fila border-bottom-line">
                        <span class="custom-label">Sitio Web:</span>
                        <span class="value">
                            {{ objReporteBasico?.ContactabilidadComercial?.SitioWeb || 'Sin información' }}
                        </span>
                    </div>

                    <div class="fila border-bottom-line">
                        <span class="custom-label">Cant. Empleados:</span>
                        <span class="value">
                            {{
                            objReporteBasico?.AntecedentesFinancieros?.NumeroEmpleados ?
                            (objReporteBasico?.AntecedentesFinancieros?.NumeroEmpleados | number: '1.0-0') :
                            'Sin información'
                            }}
                        </span>
                    </div>

                    <div class="fila border-bottom-line">
                        <span class="custom-label">Tipo de Sociedad:</span>
                        <span class="value">{{ objReporteBasico?.InformacionBasica?.TipoSociedad || 'Sin información'
                            }}</span>
                    </div>

                </ng-template>
            </ng-container>

            <div *ngIf="mallaSocietaria" class="fila border-bottom-line">
                <span class="custom-label">Malla Societaria:</span>
                <span class="value">{{ mallaSocietaria }}</span>
            </div>

            <ng-container *ngIf="objReporteFinanciero && obtenerRepresentantes();">
                <div class="fila border-bottom-line">
                    <span class="custom-label">Representantes legales:</span>
                    <mat-list role="list" class="value">
                        <ul class="value pl-4">
                            <li *ngFor="let representante of objReporteFinanciero?.CarpetaTributariaElectronicaReporte?.Reporte?.representantes;">
                                {{
                                    representante.rut && representante.dv ?
                                    (representante.rut + '-' + representante.dv | rutFormat) : ''}} {{representante.rut && representante.dv && representante.nombreRazonSocial ? '(' : ''}}{{representante.nombreRazonSocial || ''}}{{representante.rut && representante.dv && representante.nombreRazonSocial ? ')' :
                                    ''
                                }}
                            </li>
                        </ul>
                    </mat-list>
                </div>

                <ng-template #elseRepresentante>
                    Sin información
                </ng-template>
            </ng-container>

            <div *ngIf="objReporteBasico && !isPersonaNatural" class="fila border-bottom-line">
                <span class="custom-label">Tamaño de la empresa:</span>
                <span class="value">{{ objReporteBasico?.AntecedentesFinancieros?.TamanoEmpresaDescripcion || 'Sin información' }}</span>
            </div>

            <div *ngIf="objReporteBasico && !isPersonaNatural" class="fila border-bottom-line">
                <span class="custom-label">Subsegmento:</span>
                <span class="value">{{ objReporteBasico?.AntecedentesFinancieros?.TamanoSubsegmento || 'Sin información'
                    }}</span>
            </div>

            <div *ngIf="objReporteBasico && !isPersonaNatural" class="fila border-bottom-line">
                <span class="custom-label">Tramo:</span>
                <span class="value">{{ objReporteBasico?.AntecedentesFinancieros?.TramoSegunVentas || 'Sin información'
                    }}</span>
            </div>

            <div *ngIf="objReporteBasico && !isPersonaNatural" class="fila border-bottom-line">
                <span class="custom-label">Rango Facturación:</span>
                <span class="value">{{ objReporteBasico?.AntecedentesFinancieros?.TamanoEmpresaRango || 'Sin información'
                    }}</span>
            </div>

            <div *ngIf="objReporteBasico && !isPersonaNatural" class="fila border-bottom-line">
                <span class="custom-label">Patrimonio:</span>
                <span class="value">{{ objReporteBasico?.AntecedentesFinancieros?.Patrimonio || 'Sin información' }}</span>
            </div>
        </div>

        <div class="col derecha">
            <div *ngIf="objResumenDeudaSbif && objectKeys(objResumenDeudaSbif).length > 0" class="fila border-bottom-line">
                <span class="custom-label">Deuda al:</span>
                <span class="value">{{ periodoDeuda | date:'LLL yyyy' | titlecase }}</span>
            </div>

            <div *ngIf="objResumenDeudaSbif && objectKeys(objResumenDeudaSbif).length > 0" class="fila border-bottom-line">
                <span class="custom-label">Deuda vigente Bancarios y leasing M$:</span>
                <span class="value">
                    {{
                        objResumenDeudaSbif && objectKeys(objResumenDeudaSbif).length > 0 ?
                        (sumarTotalesDeudas(['dirvigente', 'leasingvig']) | number: '1.0-0') :
                        'Sin información'
                    }}
                </span>
            </div>

            <div *ngIf="objResumenDeudaSbif && objectKeys(objResumenDeudaSbif).length > 0" class="fila border-bottom-line">
                <span class="custom-label">Deuda morosa Bancarios y leasing M$:</span>
                <span class="value">
                    {{
                        objResumenDeudaSbif && objectKeys(objResumenDeudaSbif).length > 0 ?
                        (sumarTotalesDeudas(['dirmorosa', 'dirvencida', 'castigadadirecta', 'dirven180mayor3year', 'leasingmor']) | number: '1.0-0') :
                        'Sin información'
                    }}
                </span>
            </div>

            <div *ngIf="objReporteBasico" class="fila border-bottom-line">
                <span class="custom-label">Total Impago Empresa (Dicom) M$:</span>

                <div class="fila py-0">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text border-0 bg-white" disabled>#</span>
                        </div>
                        <div class="form-control border-0" disabled>
                            {{ utilsService.esNumeroValido(objReporteBasico?.AntecedentesComerciales?.Resumen?.TotalImpagosCantidad) ? (objReporteBasico?.AntecedentesComerciales?.Resumen?.TotalImpagosCantidad | number: '1.0-0') : 'Sin información' }}
                        </div>
                    </div>

                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text border-0 bg-white" disabled>$</span>
                        </div>
                        <div class="form-control border-0" disabled>
                            {{ utilsService.esNumeroValido(objReporteBasico?.AntecedentesComerciales?.Resumen?.TotalImpagosMonto) ? (objReporteBasico?.AntecedentesComerciales?.Resumen?.TotalImpagosMonto | number: '1.0-0'): 'Sin información'}}
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="objResumenDeudaSbif && objectKeys(objResumenDeudaSbif).length > 0" class="fila border-bottom-line">
                <span class="custom-label">LC bancarias disponibles M$:</span>
                <span class="value">
                    {{
                        objResumenDeudaSbif && objectKeys(objResumenDeudaSbif).length > 0 ?
                        (sumarTotalesDeudas(['lineacredito']) | number: '1.0-0') :
                        'Sin información'
                    }}
                </span>
            </div>

            <div *ngIf="objResumenDeudaSbif && objectKeys(objResumenDeudaSbif).length > 0" class="fila border-bottom-line">
                <span class="custom-label">Crédito contingentes M$:</span>
                <span class="value">
                    {{
                        objResumenDeudaSbif && objectKeys(objResumenDeudaSbif).length > 0 ?
                        (sumarTotalesDeudas(['credcontingente']) | number: '1.0-0') :
                        'Sin información'
                    }}
                </span>
            </div>

            <div *ngIf="totalJudicial" class="fila border-bottom-line">
                <span class="custom-label">Causas judiciales (Cantidad de causas laborales, civiles o cobranza):</span>
                <span class="value">
                    <ng-container *ngIf="objReporteJudicial || totalJudicial || totalJudicial == 0; else judicialSinInfo">
                        {{ totalJudicial }}
                    </ng-container>

                    <ng-template #judicialSinInfo>Sin información</ng-template>
                </span>
            </div>

            <div *ngIf="objReporteBoletinConcursal" class="fila border-bottom-line">
                <span class="custom-label">Boletin Concursal:</span>
                <span class="value">
                    {{ objReporteBoletinConcursal && obtenerPrincipal() ? 'SI': 'NO'}}
                </span>
            </div>

            <div *ngIf="objReporteBasico" class="fila border-bottom-line">
                <span class="custom-label">Número de Vehiculos:</span>
                <span class="value">
                    {{
                    utilsService.esNumeroValido(objReporteBasico?.AntecedentesFinancieros?.NumeroVehiculos) ?
                    (objReporteBasico?.AntecedentesFinancieros?.NumeroVehiculos | number: '1.0-0') :
                    'Sin información'
                    }}
                </span>
            </div>

            <div *ngIf="objReporteBasico" class="fila border-bottom-line">
                <span class="custom-label">Valor de Vehiculos:</span>
                <span class="value">
                    {{
                    utilsService.esNumeroValido(objReporteBasico?.AntecedentesFinancieros?.ValorVehiculos) ?
                    '$ ' + (objReporteBasico?.AntecedentesFinancieros?.ValorVehiculos | number: '1.0-0') :
                    'Sin información'
                    }}
                </span>
            </div>

            <div *ngIf="objReporteBasico" class="fila border-bottom-line">
                <span class="custom-label">Número de Bienes Raices:</span>
                <span class="value">
                    {{
                    utilsService.esNumeroValido(objReporteBasico?.AntecedentesFinancieros?.NumeroBienesRaices) ?
                    (objReporteBasico?.AntecedentesFinancieros?.NumeroBienesRaices | number: '1.0-0') :
                    'Sin información'
                    }}
                </span>
            </div>

            <div *ngIf="objReporteBasico" class="fila border-bottom-line">
                <span class="custom-label">Valor de Bienes Raices:</span>
                <span class="value">
                    {{
                    utilsService.esNumeroValido(objReporteBasico?.AntecedentesFinancieros?.ValorBienesRaices) ?
                    '$ ' + (objReporteBasico?.AntecedentesFinancieros?.ValorBienesRaices | number: '1.0-0') :
                    'Sin información'
                    }}
                </span>
            </div>

            <div *ngIf="objReporteEmpresaDia" class="fila border-bottom-line">
                <span class="custom-label">Empresa en día:</span>
                <span class="value">
                    {{ objReporteEmpresaDia && objectKeys(objReporteEmpresaDia).length > 0 ? 'SI': 'NO' }}
                </span>
            </div>
        </div>
    </div>

    <div *ngIf="objReporteRegCheq" class="mt-4 avoid-break-inside">
        <h2>Compliance</h2>
        <div  class="border mt-4">
            <app-regcheq-viewer [content]="this.objReporteRegCheq" [showHeader]="false"></app-regcheq-viewer>
        </div>
    </div>


    <div class="two-equal-columns-grid border mt-4 py-2 avoid-break-inside">
        <div class="full-width-column p-4">
            <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
            <strong>Riesgo</strong>
        </div>
        <div class="col">
            <div class="fila border-bottom-line">
                <span class="custom-label">Clasificación Comercial:</span>
                <span *ngIf="!objReporteBasico?.Riesgo?.Clasificacion" class="value">Sin información</span>
            </div>

            <div *ngIf="objReporteBasico?.Riesgo?.Clasificacion" class="pb-4">
                <div class="w-100">
                    <div style="padding: 0.75rem 3.5%;">
                    <div style="width:94%;">
                        <div style="width:22px;text-align: center;"
                        [ngStyle]="{'margin-left': setClasificacionPosition(objReporteBasico?.Riesgo?.Clasificacion || '') + '%'}">
                        <div style="width:26px;height:12px;text-align: center; font-size: 1.5rem; font-weight: bold;">
                            {{ objReporteBasico?.Riesgo?.Clasificacion }}
                        </div>
                        <div style="width:26px;height:14px;text-align: center;"><i class="arrow down"></i></div>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="w-100">
                    <div><img src="assets/img/barra.jpg" width="100%" alt="" /></div>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="fila border-bottom-line">
                <span class="custom-label">Clasificación histórica:</span>
                <span *ngIf="!(graph && objReporteBasico?.Riesgo?.ClasificacionHistorica)" class="value">Sin información</span>
            </div>
            <div *ngIf="graph && objReporteBasico?.Riesgo?.ClasificacionHistorica" class="pb-4">
                <div [chart]="graph" class="graphContent"></div>
            </div>
        </div>
    </div>

    <div *ngIf="objReporteFinanciero" class="border mt-4 avoid-break-inside">
        <div class="p-4">
            <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
            <strong>Antecedentes financieros (resumen)</strong>
        </div>

        <div class="col py-4">
            <div class="mat-table-container">
                <table mat-table [dataSource]="resumenFinancieroData">

                    <ng-container matColumnDef="concepto">
                        <th mat-header-cell *matHeaderCellDef>Concepto</th>
                        <td mat-cell *matCellDef="let element" class="fw-500">
                            {{ element.concepto }}
                        </td>
                    </ng-container>

                    <ng-container *ngFor="let periodo of periodosResumenFinanciero" [matColumnDef]="periodo">
                        <th mat-header-cell *matHeaderCellDef class="w-dynamic">{{ periodo }}</th>
                        <td mat-cell *matCellDef="let element" class="w-dynamic">
                        {{ element[periodo] }}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="resumenFinancieroColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: resumenFinancieroColumns;"></tr>
                </table>
            </div>
        </div>
    </div>

    <div *ngIf="validarIfInformation(objReporteBasico) && objReporteBasico?.InformacionBasica?.TipoReporte !== SIN_INFORME_TEXT" class="two-boxes-grid mt-4 avoid-break-inside">

        <div class="border">
            <div class="p-4">
                <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                <strong>Antecedentes societarios</strong>
            </div>

            <div class="col">

                <ng-container *ngIf="validaObjetoAntecedentes(); else antecedentesComercial">
                    <div class="fila">
                        <span class="custom-label">Rut:</span>
                        <span>
                            {{
                                (objReporteFinanciero?.CarpetaTributariaElectronicaReporte?.DatosBasicosSolicitud?.Rut || '') | number: '1.0-0'}}-{{(objReporteFinanciero?.CarpetaTributariaElectronicaReporte?.DatosBasicosSolicitud?.DV || '') | titlecase
                            }}
                        </span>
                    </div>
                    <div class="fila">
                        <span class="custom-label">Nombre:</span>
                        <span>{{ objReporteFinanciero?.CarpetaTributariaElectronicaReporte?.Reporte?.nombre }}</span>
                    </div>
                </ng-container>

                <ng-template #antecedentesComercial>
                    <div class="fila">
                        <span class="custom-label">Rut:</span>
                        <span *ngIf="objReporteBasico && objReporteBasico?.InformacionBasica" class="value">
                            {{ (objReporteBasico?.InformacionBasica?.Rut || '') | rutFormat }}
                        </span>
                    </div>
                    <div class="fila">
                        <span class="custom-label">Nombre:</span>
                        <span *ngIf="objReporteBasico && objReporteBasico?.InformacionBasica">
                            {{ objReporteBasico?.InformacionBasica?.NombreORazonSocial }}
                        </span>
                    </div>
                </ng-template>

                <mat-tree [dataSource]="dataSourceSocios" [treeControl]="treeControl">
                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                        <button mat-icon-button disabled></button>
                        {{node.name}}
                    </mat-tree-node>
                    <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                        <button mat-icon-button matTreeNodeToggle
                                [attr.aria-label]="'Toggle ' + node.name">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                        </button>
                        {{node.name}}
                    </mat-tree-node>
                </mat-tree>

            </div>
        </div>
        <div class="border">
            <div class="p-4">
                <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                <strong>Antecedentes comerciales</strong>
            </div>
            <div class="col py-4">
                <div class="mat-table-container">
                    <table mat-table [dataSource]="antecedentesComercialesData" class="equal-table">

                        <ng-container matColumnDef="concepto">
                            <th mat-header-cell *matHeaderCellDef>Concepto</th>
                            <td mat-cell *matCellDef="let element" class="fw-500">
                                {{ element.concepto }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="montoMiles">
                            <th mat-header-cell *matHeaderCellDef>Monto miles</th>
                            <td mat-cell *matCellDef="let element" class="text-right">
                                {{ element.montoMiles }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="cantidad">
                            <th mat-header-cell *matHeaderCellDef>Cantidad</th>
                            <td mat-cell *matCellDef="let element" class="text-right">
                                {{ element.cantidad }}
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="antecedentesComercialesColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: antecedentesComercialesColumns;"></tr>

                        <tr class="mat-mdc-row" *matNoDataRow>
                            <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="antecedentesComercialesColumns.length">
                                No hay datos disponibles
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

    </div>

    <div *ngIf="objReporteBasico && reporteConInformeComercial === true" class="border mt-4 avoid-break-inside">
        <div class="p-4">
            <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
            <strong>Antecedentes sociedades</strong>
        </div>

        <div class="col py-4">
            <div class="mat-table-container">
                <table mat-table [dataSource]="antecedentesSociedadesData">
                    <mat-text-column name="Rut"></mat-text-column>
                    <mat-text-column name="Nombre"></mat-text-column>

                    <tr mat-header-row *matHeaderRowDef="antecedentesSociedadesColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: antecedentesSociedadesColumns;"></tr>

                    <tr class="mat-mdc-row" *matNoDataRow>
                        <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="antecedentesSociedadesColumns.length">
                            No hay datos disponibles
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>

    <div *ngIf="objReporteBasico" class="border mt-4 avoid-break-inside">
        <div class="p-4">
            <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
            <strong>Observaciones tributarias</strong>
        </div>

        <div class="p-4">
            <strong>Documentos Timbrados</strong>
        </div>

        <div class="col py-4">
            <div class="mat-table-container">
                <table mat-table [dataSource]="documentosTimbradosData" class="equal-table">
                    <mat-text-column name="documento"></mat-text-column>
                    <mat-text-column name="anoUltimoTimbraje" headerText="Año último timbraje"></mat-text-column>

                    <tr mat-header-row *matHeaderRowDef="documentosTimbradosColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: documentosTimbradosColumns;"></tr>

                    <tr class="mat-mdc-row" *matNoDataRow>
                        <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="documentosTimbradosColumns.length">
                            No hay datos disponibles
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="p-4">
            <strong>Observaciones</strong>
        </div>

        <div class="col py-4">
            <div class="mat-table-container">
                <table mat-table [dataSource]="observacionesTributariasData" class="equal-table">
                    <ng-container matColumnDef="nombre">
                        <th mat-header-cell *matHeaderCellDef>Nombre</th>
                        <td mat-cell *matCellDef="let element" class="align-top p-3">
                            {{ element.nombre }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="descripcion">
                        <th mat-header-cell *matHeaderCellDef>Descripción</th>
                        <td mat-cell *matCellDef="let element" class="align-top p-3">
                            {{ element.descripcion }}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="observacionesTributariasColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: observacionesTributariasColumns;"></tr>

                    <tr class="mat-mdc-row" *matNoDataRow>
                        <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="observacionesTributariasColumns.length">
                            No hay datos disponibles
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>

    <div
        *ngIf="objReporteBasico?.AntecedentesComerciales?.ConsultasAlRut && (objReporteBasico?.AntecedentesComerciales?.ConsultasAlRut?.length || 0) > 0"
        class="border mt-4 avoid-break-inside">

        <div class="p-4">
            <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
            <strong>Consultas al RUT</strong>
        </div>

        <div class="p-4">
            <strong>Rut registra {{ objReporteBasico?.AntecedentesComerciales?.ConsultasAlRut?.length }} consultas</strong>
        </div>

        <div class="col py-4">
            <div class="mat-table-container">
                <table mat-table [dataSource]="consultasRutData" class="equal-table">
                    <mat-text-column name="RazonSocial" headerText="Empresa"></mat-text-column>
                    <mat-text-column name="InformeConsultado" headerText="Informe"></mat-text-column>

                    <ng-container matColumnDef="FechaConsulta">
                        <th mat-header-cell *matHeaderCellDef>Fecha</th>
                        <td mat-cell *matCellDef="let element" class="align-top p-3">
                            {{ element.FechaConsulta | date: 'dd-MM-YYYY' }}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="consultasRutColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: consultasRutColumns;"></tr>

                    <tr class="mat-mdc-row" *matNoDataRow>
                        <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="consultasRutColumns.length">
                            No hay datos disponibles
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>

    <div *ngIf="objReporteBasico?.InformacionBasica?.TipoReporte !== SIN_INFORME_TEXT" class="border mt-4 avoid-break-inside">

        <div class="p-4">
            <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
            <strong>Protestos y morosidades</strong>
        </div>

        <div class="px-5 d-flex justify-content-end">
            <strong>Total M$: {{
                ((objReporteBasico?.AntecedentesComerciales?.Resumen?.ProtestosMonto || 0) +
                (objReporteBasico?.AntecedentesComerciales?.Resumen?.MorosidadesMonto || 0)) |
                currency:'CLP':'':'1.0-0'
            }}
            </strong>
        </div>

        <div class="col py-4">
            <div class="mat-table-container">
                <table mat-table [dataSource]="morosidadesProtestosData">
                    <mat-text-column name="tipoDocumento" headerText="Doc."></mat-text-column>
                    <mat-text-column name="localidad"></mat-text-column>
                    <mat-text-column name="librador"></mat-text-column>
                    <mat-text-column name="tipoDeuda" headerText="Deuda"></mat-text-column>
                    <mat-text-column name="mercado"></mat-text-column>
                    <mat-text-column name="tipoCredito" headerText="Crédito"></mat-text-column>
                    <mat-text-column name="nChequeOperacion" headerText="N°Cheque"></mat-text-column>

                    <ng-container matColumnDef="monto">
                        <th mat-header-cell *matHeaderCellDef>Monto</th>
                        <td mat-cell *matCellDef="let element">
                            {{element.moneda}} {{element.monto | currency:'CLP':'':'1.0-0' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="fechaVencimiento">
                        <th mat-header-cell *matHeaderCellDef>Vencimiento</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.fechaVencimiento | date: 'dd-MM-YYYY' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="fechaPublicacion">
                        <th mat-header-cell *matHeaderCellDef>Publicación</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.fechaPublicacion | date: 'dd-MM-YYYY' }}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="morosidadesProtestosColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: morosidadesProtestosColumns;"></tr>

                    <tr class="mat-mdc-row" *matNoDataRow>
                        <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="morosidadesProtestosColumns.length">
                            No hay datos disponibles
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>

    <div *ngIf="objReporteBasico?.InformacionBasica?.TipoReporte !== SIN_INFORME_TEXT" class="border mt-4 avoid-break-inside">

        <div class="p-4">
            <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
            <strong>Información boletín laboral</strong>
        </div>

        <div class="px-5 d-flex justify-content-end">
            <strong>
                Total M$: {{ objReporteBasico?.AntecedentesComerciales?.Resumen?.InfraccionesLaboralesMonto | currency:'CLP':'':'1.0-0' }}
            </strong>
        </div>

        <div class="col py-4">
            <div class="mat-table-container">
                <table mat-table [dataSource]="boletinLaboralData">
                    <mat-text-column name="motivo"></mat-text-column>
                    <mat-text-column name="meses"></mat-text-column>
                    <mat-text-column name="institucion"></mat-text-column>
                    <mat-text-column name="boletin" headerText="Boletín"></mat-text-column>
                    <mat-text-column name="pagina" headerText="Página"></mat-text-column>
                    <mat-text-column name="insp"></mat-text-column>
                    <mat-text-column name="tipoInfraccion" headerText="Tipo infracción"></mat-text-column>
                    <mat-text-column name="resolutionNumber" headerText="Resolución"></mat-text-column>

                    <ng-container matColumnDef="monto">
                        <th mat-header-cell *matHeaderCellDef>Monto</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.monto | number:'1.0-0' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="fecha">
                        <th mat-header-cell *matHeaderCellDef>Fecha</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.fecha | date: 'dd-MM-YYYY' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="fechaPublicacion">
                        <th mat-header-cell *matHeaderCellDef>Publicación</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.fechaPublicacion | date: 'dd-MM-YYYY' }}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="boletinLaboralColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: boletinLaboralColumns;"></tr>

                    <tr class="mat-mdc-row" *matNoDataRow>
                        <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="boletinLaboralColumns.length">
                            No hay datos disponibles
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>

    <div *ngIf="reportePoderJudicial" class="mt-4 avoid-break-inside">
        <h2>Poder judicial</h2>
        <div class="border mt-4 p-4">
            <app-poder-judicial-report-viewer
                [content]="reportePoderJudicial"
                [showHeader]="false"
                [fromConsolidado]="true" 
                [fromFlujoDeCredito]="true">
            </app-poder-judicial-report-viewer>
        </div>
    </div>

    <div *ngIf="reporteBoletinConcursal" class="mt-4 avoid-break-inside">
        <h2>Boletin Concursal</h2>
        <div class="border mt-4 p-4">
            <app-boletin-concursal-report-viewer [content]='reporteBoletinConcursal' [showHeader]="false">
            </app-boletin-concursal-report-viewer>
        </div>
    </div>

    <div *ngIf="reporteDeudaSbif" class="mt-4 avoid-break-inside">
        <h2 class="mb-4">Deuda Sbif</h2>
        <app-deuda-leasing-sbif-viewer [content]='reporteDeudaSbif' [typeTX]="false" [showHeader]="false">
        </app-deuda-leasing-sbif-viewer>
    </div>

    <div *ngIf="reporteCteVentasBalancesRentas" class="mt-4 avoid-break-inside">
        <h2>Reporte Financiero</h2>
        <div class="border mt-4 p-4">
            <app-reporte-full-viewer
                [reporteFullContent]="reporteCteVentasBalancesRentas"
                [showHeader]="false"
                [nombreBasico]="reporteBasicReport?.InformacionBasica?.NombreORazonSocial || ''">
            </app-reporte-full-viewer>
        </div>
    </div>

    <div *ngIf="reporteBienesRaices" class="mt-4 avoid-break-inside">
        <h2>Bienes Raices</h2>
        <div class="border mt-4 p-4">

            <ng-container *ngIf="reporteBienesRaices?.bienesraicesReporte?.bienesRaices?.listadoBienesRaices &&  reporteBienesRaices.bienesraicesReporte.bienesRaices.listadoBienesRaices.length > 0; else bienesSinInfo">
                <app-bienes-raices-viewer [content]='reporteBienesRaices' [showHeader]="false" [fromConsolidado]="true">
                </app-bienes-raices-viewer>
            </ng-container>

            <ng-template #bienesSinInfo>
                Sin información
            </ng-template>

        </div>
    </div>

    <div *ngIf="reporteVehiculos" class="mt-4">
        <h2>Vehículos</h2>
        <div class="border mt-4 p-4">

            <ng-container *ngIf="reporteVehiculos?.vehiculoReporte?.vehiculos?.listadoVehiculos && reporteVehiculos.vehiculoReporte.vehiculos.listadoVehiculos.length > 0; else vehiculosSinInfo">
                <app-vehiculos-viewer [content]='reporteVehiculos' [showHeader]="false" [fromConsolidado]="true">
                </app-vehiculos-viewer>
            </ng-container>

            <ng-template #vehiculosSinInfo>
                Sin información
            </ng-template>

        </div>
    </div>

</div>

<ng-container *ngIf="plantillaNoEditable === false">
    <ng-template #botonFinalizar>
        <ng-container *ngIf="validaUsuarioAdmin()">
            <div class="col-12 d-flex justify-content-center pt-4 no-print">
                <button class="btn btn-sm btn-primary mx-2 rounded-header" (click)="volverEtapaPrevia()">
                    Devolver Etapa Previa
                </button>
            </div>
        </ng-container>
    </ng-template>

    <ng-container *ngIf="stepper === 4 else botonFinalizar">

        <div class="col-12 d-flex justify-content-center pt-4 no-print">
            <button class="btn btn-sm btn-primary mx-2 rounded-header" (click)="guardarFicha()">
                Guardar
            </button>
            <button class="btn btn-sm btn-primary mx-2 rounded-header"
                [disabled]="objectKeys(fichaGuardada).length > 0 ? null : true" (click)="avanzarFlujo()">
                Continuar
            </button>
        </div>

    </ng-container>
</ng-container>